<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <div id="pnlista" class="card" >
                    <div class="card-header" style="display: flex; justify-content: space-between;" ><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                       
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <button @click.prevent="mtdMostrarEsconderFiltro()" :class="!mostrafiltro ? 'btn primary' : 'btn info'" type="button" >
                                        <span>Filtros</span>
                                        <span><i  :class="!mostrafiltro ? 'bi bi-chevron-double-down' : 'bi bi-chevron-double-up'" ></i></span>
                                    </button>
                                </div> 
                                <div v-show="mostrafiltro" class="row">
                                    <div class="col-sm-4 col-md-2 col-lg-2">
                                        <label for="cbopfiltro">Filtrar:</label>
                                        <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                            <!-- <option value="0">Código</option> -->
                                            <option value="1">Descrição</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-8 col-md-6 col-lg-6">
                                        <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                        <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <div style="padding-top: 20px;">
                                    <button type="button" id="btlistar" style="width: 100%;" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="bi bi-search"></i> Listar</button>
                                </div>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstmetas"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="bi bi-chevron-compact-up"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="bi bi-chevron-down"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                       
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="bgsaldo" slot-scope="item">
                                        <span  style="color: darkgreen;" >{{mtdformatavalordecimal(item.row.valor, 'R$')}}</span>
                                    </template>
                                   
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="bi bi-pencil"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="bi bi-trash-fill"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstmetas.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="bi bi-file-earmark"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" >
                    <div class="card-header" style="display: flex; justify-content: space-between;">
                        <span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close btn btn-sm" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-10 col-lg-10">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbvalor">Valor:</label>
                                <money type="text" class="form-control form-control-sm" id="cbvalor" v-model="vvalor" v-bind="money" data-bv-group=".group" style="text-align: right;"></money>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <span>Toque no adesivo para mudar</span>
                            </div>
                            <div style="padding-top: 20px;" class="col-sm-12 col-md-12 col-lg-12">
                                <div style="display: flex; justify-content: center;" >
                                    <div class="card" >
                                        <div class="card-body" style="padding: 0" >
                                            <i :class="'bi '+vadesivo" @click.prevent="mtdmudaradesivo()" style="font-size: 91px"></i> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>* Campos obrigatórios</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="bi bi-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="bi bi-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="bi bi-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="bi bi-ban"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal id="modalsetaradesivo" :adaptive="true" name="modalsetaradesivo" :height="600">
            <div class="container" style="max-height: 80vh; overflow-y: auto;">
                <ul class="row row-cols-3 row-cols-sm-4 row-cols-lg-6 row-cols-xl-8 list-unstyled list">
                    <li v-for="(icone, index) in lstadesivos" :key="index" @click.prevent="mtdconfirmaicon(icone.codigo_classe)" class="col mb-4" data-name="0-circle" data-tags="number numeral" data-categories="shapes">
                        <a class="d-block text-body-emphasis text-decoration-none">
                            <div :style="icone.codigo_classe === vadesivo ? 'background-color: #ffffff !important' : ''" class="px-3 py-4 mb-2 bg-body-secondary text-center rounded">
                                <i style="font-size: 25px;" :class="'bi ' + icone.codigo_classe"></i>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </modal>


    </div>
</template>
<script>
    /* eslint-disable */        
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import Swal from 'sweetalert2'
    import util from '../util.js'

    export default {
        name: 'cadmetas',
        components:{
            VueBootstrap4Table,
            vPagination,
        },
        data: function() {
            return {
                lstmetas  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud         :  0,
                vid            : '',
                vdescricao     : '',
                vvalor         : 0,
                vadesivo       : 'bi-check',



                //variaveis setar objetivos
                lstadesivos: [],
  

                //variável para habilitação dos campos
                ativadesativa       : true,
                money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'METAS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },     
                    {
                        label: 'Valor',
                        name : 'valor',
                        slot_name: 'bgsaldo',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                },
                mostrafiltro : false
            }
        },
        methods:{
            mtdMostrarEsconderFiltro(){
                if(this.mostrafiltro){
                    this.mostrafiltro = false
                }else{
                    this.mostrafiltro = true
                }
            },
            mtdconfirmaicon(icone){
                this.vadesivo = icone;
                this.$modal.hide("modalsetaradesivo");
            },
            mtdmudaradesivo(){
                let vself           = this;    
                let parametros      = [
                    {parametro: 'idusuario',    valor : localStorage.getItem('iduser')},
                    {parametro: 'op',           valor  : 'listaradesivos'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', util.servidor+'/controller/utilitario.php');
                retorno.then(function (response) {
                    vself.lstadesivos = response.data;
                    vself.$modal.show("modalsetaradesivo");

                }).catch(function (response) {
                    //alert('Erro ao consultar registros');
                });
            },
            mtdformatavalordecimal(valor, digitos){
                return util.formatarvalor(valor, digitos);
			},    
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and m.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and m.upper(descricao) like upper("'+this.pconteudo+'%")';
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idusuario',    valor : localStorage.getItem('iduser')},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', util.servidor+'/controller/cadmetas.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregameta(1);
                }).catch(function (response) {
                    //alert('Erro ao consultar registros');
                });
            },
            mtdcarregameta(ipagina){
                var vself       = this;
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idusuario',    valor : localStorage.getItem('iduser')},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', util.servidor+'/controller/cadmetas.php');
                retorno.then(function (response) {
                    vself.lstmetas = response.data; 
                }).catch(function (response) {
                    vself.lstmetas = [];
                });
            },
            resetarDados() {
               
                this.vid           = '';
                this.vdescricao    = '';
                this.vvalor        = 0;
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                vself.mtddefault();
            },
            mtdnovo(){
               
                this.itensbc.item2.titulo = 'INCLUSÃO DE METAS';
                this.itensbc.item1.ativo = true;
                this.itensbc.item2.ativo = true;
                this.ativadesativa = false;
                this.mtdpreparacrud(1);
                
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstmetas = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                Swal.fire({
                title: "Confirmação",
                text: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim" }).
                then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        vself.mtdregistro();
                    }else{
                        $('#btgravar').focus();
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let filtro      = ' and m.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idusuario',    valor : localStorage.getItem('iduser')},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', util.servidor+'/controller/cadmetas.php');
                retorno.then(function (response) {
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                  
                });
            },
            mtdalterar(item){
             
                this.itensbc.item2.titulo = 'ALTERAÇÃO DE METAS';
                this.itensbc.item1.ativo = true;
                this.itensbc.item2.ativo = true;
                this.ativadesativa = false;
                this.mtdpreparacrud(2);
                this.mtdlocalizaregistro(item.id);
                
            },
            mtdexcluir(item){
           
                this.itensbc.item2.titulo = 'EXCLUSÃO DE METAS';
                this.itensbc.item1.ativo = true;
                this.itensbc.item2.ativo = true;
                this.ativadesativa = true;
                this.mtdpreparacrud(3);
                this.mtdlocalizaregistro(item.id);
                
            },
            mtdigualarcampos(registro){
                console.log("aqui");
                this.vid                 = registro.id;
                this.vdescricao          = registro.descricao;
                this.vvalor              = registro.valor;
                this.vadesivo            = registro.adesivo;
            },
            mtdregistro(){
                let vself  = this;
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'valor'             : this.vvalor,
                    'adesivo'           : this.vadesivo
                };
                let parametros      = [
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idusuario',    valor : localStorage.getItem('iduser')},
                ];
                let retorno     = util.reqaxios(parametros, 'post', util.servidor+'/controller/cadmetas.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data)){
                        util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregameta(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                util.notif('error', 'Informação!', response.data.substring(4));
                                break;
                            case 'E': default:
                                util.notif('error', 'Informação!', response.data.substring(4));
                                break;
                        }
                    }
                }).catch(function (response) {
                    alert('Erro ao processar o registo. Descrição do erro: '+response.message)
                });
            },
            select2def(){
                let sqliniusuario = 'select id, nome from tbcategorias ';
                let sqlfimusuario = 'where upper(nome) like upper("%@@%") and idusuario ='+localStorage.getItem('iduser');

            }
        },
        
        mounted: function () {
            let vself = this;
            $('#pncadastro').hide();
            $('#pnlista').hide();
            $('#pnlista').show(700);
            vself.mtdexecutapesquisa();
            vself.select2def();
        },
        computed:{
            validou() {
                return this.vdescricao === '';
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregameta(val);
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
</style>